import React, { useEffect, useState } from "react";

// Components

import { Case, If } from "~/common/components/If";
import { API_STATE, PAGE_STATE } from "~/common/constants/state";

import useRequest from "~/common/hooks/useRequest";
import { useGlobalStore } from "~/store";

// Assets
import "~/assets/sass/pages/mypage/admin/auth.scss";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import View from "./View";
import Edit from "./Edit";
import List from "./list";
import { AuthPluginDescConstant } from "./AuthPluginDescConstant";

export const AuthPageIntro = () => {
	const { t } = useTranslation();
	return (
		<div className="pageIntro">
			<CautionIcon />
			<div className="content">
				<h3>
					<b>{t("pages.myPage.admin.AuthPage.content.h3")}</b>
				</h3>
				<p className="pre">{t("pages.myPage.admin.AuthPage.content.p")}</p>
			</div>
		</div>
	);
};

const AdminAuthPage = ({
	selectUser, setSelectUser, page, setPage, memberList,
	authEditAlertModal,
	setAuthEditAlertModal,
	authEditAlertContent,
	alertState,
}) => {
	const [
		{
			user: { info },
		},
	] = useGlobalStore();

	//팀원 리스트
	const [authMemberList, setAuthMemberList] = useState([]);
	//메뉴 리스트
	const [pluginList, setPluginList] = useState([]);
	//선택된 유저

	//권한 리스트
	const [authorityList, setAuthorityList] = useState([]);
	//팀원 리스트 조회
	const authMemberListRequest = useRequest("get", "/vc/admin/auth/member");
	//플러그인 리스트 조히
	const pluginListRequest = useRequest("get", "/vc/admin/auth/plugin");
	//상세 권한 조회
	const getAuthorityRequest = useRequest("get", "/vc/admin/auth/detail");
	//Edit Page Alert Modal
	//플러그인 메뉴 리스트 조회 Request
	useEffect(() => {
		pluginListRequest.singleCall();
	}, [pluginListRequest]);

	//플러그인 메뉴 리스트 조회 Response
	useEffect(() => {
		switch (pluginListRequest.state) {
			case API_STATE.done:
				let newData = [];
				pluginListRequest.response.data.forEach((d) => {
					const newSub = d.subMenu.map((s) => ({
						...s,
						desc: AuthPluginDescConstant.find((p) => s.idx === p.idx)?.desc || "-",
					})).filter(ele => ele.idx === 17 || ele.viewMode);

					newData.push({ ...d, subMenu: newSub });
				});

				setPluginList(newData);
				break;
			case API_STATE.error:
				console.log("error", pluginListRequest.error);
				alert(t("common.commonWord.alert.wait2"));
				break;
			default:
				break;
		}
	}, [pluginListRequest.state, pluginListRequest.done, pluginListRequest.error]);

	//팀원 리스트 조회 Request
	useEffect(() => {
		authMemberListRequest.singleCall();
	}, [authMemberListRequest]);

	//팀원 리스트 조회 Response
	useEffect(() => {
		switch (authMemberListRequest.state) {
			case API_STATE.done:
				const newData = authMemberListRequest.response.data.map((d) => ({
					...d,
					roleName:
						d.role === "admin"
							? t("pages.myPage.userType.admin")
							: d.role === "user"
								? t("pages.myPage.userType.user")
								: t("pages.myPage.userType.manager"),
				}));
				setAuthMemberList(newData);
				if (selectUser === undefined) {
					setSelectUser(newData[0]);
				} else {
					setSelectUser(newData.find((d) => d.idx === selectUser.idx));
				}
				setPage(PAGE_STATE.VIEW);
				break;
			case API_STATE.error:
				console.log("error", authMemberListRequest.error);
				alert(t("common.commonWord.alert.wait2"));
				break;
			default:
				break;
		}
	}, [authMemberListRequest.state, authMemberListRequest.done, authMemberListRequest.error]);

	//선택한 유저 권한 조회 Request
	useEffect(() => {
		if (authMemberList.length > 0 && selectUser !== undefined) {
			getAuthorityRequest.call(selectUser.idx, "path");
		}
	}, [selectUser]);

	//선택한 유저 권한 조회 Response
	useEffect(() => {
		switch (getAuthorityRequest.state) {
			case API_STATE.done:
				let newData = [];

				if (getAuthorityRequest.response.data === "admin") {
					pluginList.forEach((p) => {
						const menuAuth = [];
						p.subMenu.map((s) => {
							if (s.title === "Apply 리스트") return;
							menuAuth.push({
								...s,
								viewAuth: true,
								editAuth: true,
							});
						});
						newData.push({ ...p, subMenu: menuAuth });
					});
				} else {
					const viewAuth = getAuthorityRequest.response.data.viewAuth;
					const editAuth = getAuthorityRequest.response.data.editAuth;

					pluginList.forEach((p) => {
						const menuAuth = [];
						p.subMenu.map((s) => {
							if (s.title === "Apply 리스트") return;
							menuAuth.push({
								...s,
								viewAuth:
									viewAuth.length > 0 &&
										viewAuth.find((v) => v.pluginMenuIdx === s.idx)
										? viewAuth.find((v) => v.pluginMenuIdx === s.idx).auth
										: false,
								editAuth:
									editAuth.length > 0 &&
										editAuth.find((v) => v.pluginMenuIdx === s.idx)
										? editAuth.find((v) => v.pluginMenuIdx === s.idx).auth
										: false,
							});
						});
						newData.push({ ...p, subMenu: menuAuth });
					});
				}

				setAuthorityList(newData);
				break;
			case API_STATE.error:
				console.log("error", getAuthorityRequest.error);
				alert(t("common.commonWord.alert.wait2"));
				break;
			default:
				break;
		}
	}, [getAuthorityRequest.state, getAuthorityRequest.done, getAuthorityRequest.error]);


	return (
		<div className="p__admin-auth">
			<AuthPageIntro />
			<div className="c__both-side-cardRow">
				<List
					{...{
						page,
						setPage,
						authMemberList,
						selectUser,
						setSelectUser,
						authMemberListRequest,
						info,
					}}
				/>
				<If
					condition={page}
					{...{
						setPage,
						selectUser,
						authorityList,
						authMemberListRequest,
						getAuthorityRequest,
						authEditAlertModal,
						setAuthEditAlertModal,
						authEditAlertContent,
						alertState,
					}}
				>
					<Case condition={PAGE_STATE.VIEW}>
						<View />
					</Case>
					<Case condition={PAGE_STATE.EDIT}>
						<Edit />
					</Case>
				</If>
			</div>
		</div>
	);
};

export default AdminAuthPage;
